import { Box, Button, Icon, Modal } from "@outschool/backpack";
import { faSparkles } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { useSession } from "@outschool/ui-auth";
import React from "react";

import { HeroFilters } from "./HeroFilters";

export function HeroFiltersButtonMobile({
  category,
  updateSearchFilters,
  searchFilters,
  setShowButton,
}: $TSFixMe) {
  const { t } = useTranslation(
    "client\\components\\categories\\CategoryTutoringFilters",
  );
  const [modalOpen, setIsModalOpen] = React.useState(false);
  const [lastStep, setLastStep] = React.useState(false);
  const { isLoggedIn } = useSession();

  return (
    <Box>
      <Button
        variant={"contained"}
        size={"large"}
        sx={{
          position: "fixed",
          bottom: isLoggedIn ? 80 : 20,
          zIndex: 1,
          width: "calc(100% - 24px)",
          marginX: "12px",
          gap: "0.5em",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.5)",
        }}
        onClick={() => setIsModalOpen(true)}
      >
        {t("Personalize My Results!")}
        <Icon icon={faSparkles} />
      </Button>
      <Modal
        onClose={() => {
          setIsModalOpen(false);
          setShowButton(!lastStep);
        }}
        open={modalOpen}
        sx={{ height: "350px", top: "auto" }}
      >
        <HeroFilters
          categorySlug={category.slug}
          updateSearchFilters={updateSearchFilters}
          searchFilters={searchFilters}
          setLastStep={setLastStep}
        />
      </Modal>
    </Box>
  );
}
